import { IconButton, SxProps } from "@mui/material";
import { X } from "lucide-react";
import theme from "theme";

export default ({
  onClick,
  variant = "outlined",
  sx,
}: {
  onClick: () => void;
  variant?: "outlined" | "icon";
  size?: "small" | "medium";
  sx?: SxProps;
}) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        ...(variant === "outlined" && {
          border: `2px solid ${theme.palette.gray[3]}`,
          padding: "4px",
        }),
        ...sx,
      }}
    >
      <X color={theme.palette.text.tertiary} size={24} />
    </IconButton>
  );
};
